import React, { useMemo } from "react";
import { Chip, Grid, Modal } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Loader from "utils/Loader";
import MDButton from "components/MDButton";
import MetricsView from "./MetricsView";

const createModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: window.innerWidth < 800 ? "100%" : 800,
  // height: window.innerHeight < 800 ? 600 : 650,
  overflowX: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "0.5rem",
  p: 4,
  "& .MuiFormHelperText-root": { color: "#d32f2f" },
  overflowY: "auto",
  height: "80vh",
  outline: "none",
};

function TableFilterModal({
  open,
  handleClose,
  isModalLoading,
  options,
  modalColumns,
  setModalColumns,
  changeURL,
}) {
  // columnsWithNames is used to render selected modalColumns in the UI which contains selected modalColumns names
  const columnsWithNames = useMemo(
    () => ({
      other: modalColumns?.other?.length
        ? modalColumns.other
            .map((column) => {
              const matchedObject = options?.other?.find(
                (filterOption) => filterOption.id === column
              );
              if (!matchedObject) return null;
              return {
                id: matchedObject.id,
                name: matchedObject.name,
              };
            })
            .filter((kpi) => !!kpi)
        : [],
      kpis: modalColumns?.kpis?.length
        ? modalColumns.kpis
            .map((column) => {
              const matchedObject = options?.kpis?.find(
                (filterOption) => filterOption.id === column
              );
              if (!matchedObject) return null;
              return {
                id: matchedObject.id,
                name: matchedObject.name,
              };
            })
            .filter((kpi) => !!kpi)
        : [],
    }),
    [modalColumns, options]
  );

  const handleTableFilterChange = (key, option, value) => {
    let newColumnsOfKey = [...modalColumns[key]];
    if (value) {
      newColumnsOfKey.push(option);
    } else {
      newColumnsOfKey = newColumnsOfKey.filter((column) => column !== option);
    }
    setModalColumns({ ...modalColumns, [key]: newColumnsOfKey });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <MDBox sx={createModalStyle}>
        <MDBox
          sx={{
            position: "relative",
            pointeEvents: isModalLoading && "none",
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Loader loading={isModalLoading} zIndex="10000" />
          <MDBox
            sx={{ textTransform: "capitalize", alignItems: "flex-end", flexWrap: "wrap" }}
            display="inline-flex"
            ml={1}
          >
            <MDTypography
              variant="body1"
              sx={{ textTransform: "capitalize", mr: 1, color: "#4c4c4c", fontSize: "1rem" }}
            >
              Current View:
            </MDTypography>
            {Object.keys(modalColumns).map((key) =>
              Array.isArray(modalColumns[key]) && modalColumns[key].length > 0 ? (
                <React.Fragment key={key}>
                  <MDTypography
                    variant="body1"
                    sx={{ fontStyle: "italic", color: "#7882a6", fontSize: ".9rem" }}
                  >
                    {Array.isArray(modalColumns[key]) &&
                      modalColumns[key]?.map((appliedFilter) => {
                        const matchedLabel = columnsWithNames?.[key]?.find(
                          (obj) => obj.id === appliedFilter
                        );
                        if (!matchedLabel) return null;
                        return (
                          <Chip
                            sx={{ mr: 1 }}
                            key={appliedFilter}
                            label={matchedLabel?.name}
                            onDelete={() => handleTableFilterChange(key, appliedFilter, false)}
                          />
                        );
                      })}
                  </MDTypography>
                </React.Fragment>
              ) : null
            )}
          </MDBox>

          <MDTypography
            sx={{ marginBottom: "1rem" }}
            id="modal-modal-title"
            variant="h5"
            component="h2"
            mt={4}
          >
            Add Metrics to view
          </MDTypography>

          <MDBox sx={{ flex: 1 }}>
            <Grid container spacing={2} sx={{ flex: 1 }}>
              <Grid item xs={12} sm={6}>
                <MetricsView
                  data={options.kpis}
                  label="KPI"
                  objectKey="kpis"
                  columnsWithNames={columnsWithNames.kpis}
                  handleTableFilterChange={handleTableFilterChange}
                  includeSearch
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MetricsView
                  data={options.other}
                  label="Other Options"
                  objectKey="other"
                  columnsWithNames={columnsWithNames.other}
                  handleTableFilterChange={handleTableFilterChange}
                />
              </Grid>
            </Grid>
          </MDBox>

          <MDBox sx={{ display: "flex", justifyContent: "end", pb: [4, 4, 0], pt: [4, 4, 2] }}>
            <MDBox>
              <MDButton color="gray80" onClick={handleClose} sx={{ mr: 1, position: "relative" }}>
                Close
              </MDButton>
              <MDButton
                color="primaryRed"
                onClick={() => {
                  changeURL(null, null, modalColumns);
                  handleClose();
                }}
                sx={{ mr: 1, position: "relative" }}
              >
                Apply
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
    </Modal>
  );
}

export default TableFilterModal;
